module.exports = __webpack_public_path__ + "static/media/pix-banco-central-logo.5b53586e.svg";